import React, { memo } from "react";
import { Outlet } from "react-router-dom";
import "../assets/css/style.scss";

import Topbar from "./Topbar";
import Sidebar from "./Sidebar";
import Modal from "./Modal";
import { FloatingButton } from "../Components";

const Master = () => {
  return (
    <>
      <Topbar />
      <Sidebar />

      <section className="main-content">
        <Outlet />
      </section>

      <FloatingButton />

      <Modal />
    </>
  );
};

export default memo(Master);
